<script lang="ts" setup>
import { computed } from 'vue';
import { LinkButton, useTranslation } from '@hfc/ui-core';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';

const { getCdnUrl, getBaseUrl } = useUrlHelper();
const { t } = useTranslation();

const services = computed(() => [
  {
    title: 'Obama Care',
    text: t('services.items.obamaCare.text'),
    href: getBaseUrl('/obamacare'),
    bg: '/assets/img/bg/doctor.webp'
  },
  {
    title: t('services.items.caHealthExchange.title'),
    text: t('services.items.caHealthExchange.text'),
    href: getBaseUrl(`/${t('links.coveredCalifornia')}`),
    bg: '/assets/img/bg/stethoscope.webp'
  },
  {
    title: t('services.items.incomeGuidelines.title'),
    text: t('services.items.incomeGuidelines.text'),
    href: getBaseUrl('/covered-california/income-limits'),
    bg: '/assets/img/bg/office.webp'
  },
  {
    title: t('services.items.onlineServices.title'),
    text: t('services.items.onlineServices.text'),
    href: getBaseUrl('/covered-california-website'),
    bg: '/assets/img/bg/calculator.webp'
  },
]);
</script>

<template>
<div class="flex flex-col lg:flex-row lg:flex-wrap justify-between my-8">
  <article v-for="(service) in services" :key="service.href" class="flex lg:w-1/4 p-3">
    <div class="flex flex-col shadow-xl rounded-2xl bg-white overflow-hidden">
      <img :src="getCdnUrl(service.bg)" :alt="service.title"   class="h-40 object-cover"  />
      <div class="flex flex-1 flex-col gap-2 items-center p-6">
        <h3 class="uppercase font-bold text-lg lg:text-xl text-center text-blue-500">
          {{ service.title }}
        </h3>
        <p class="text-center text-sm lg:text-base" >{{ service.text }}</p>
        <LinkButton :href="service.href" class="mt-auto pt-4">
          <span class="font-semibold text-md lg:text-lg">{{ t('common.learnMore') }} <hfc-icon icon="arrow-right" class="ml-1 md:ml-2 mt-2" /></span>
        </LinkButton>
      </div>
    </div>
  </article>
</div>
</template>
